import Multiselect from './multiselect/Multiselect.vue';
export default Multiselect;
